import { render, staticRenderFns } from "./LogoutItem.vue?vue&type=template&id=c7989424"
import script from "./LogoutItem.vue?vue&type=script&lang=js"
export * from "./LogoutItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports